export default __webpack_public_path__ + "static/media/itforyou.cd2be311.png";